import { events } from '../helper/events';

class SidebarTrigger {
  constructor(triggerElement) {
    this.triggerElement = triggerElement;
    this.sidebarElement = null;
    this.selector = triggerElement.dataset.csTarget;
  }

  init() {
    const trigger = this;

    trigger.triggerElement.addEventListener('click', (event) => {
      event.preventDefault();
      trigger.sidebarElement = trigger.sidebarElement
                || document.querySelector(trigger.selector);

      if (!trigger.sidebarElement) { return; }

      trigger.sidebarElement.dispatchEvent(new Event(events.openSidebar));
    });
  }
}

export { SidebarTrigger };
